import React from "react";
import { IconButton } from "@mui/material";
import EditOutlined from "@mui/icons-material/EditOutlined";

import type { ProductionGroup } from "@/schemas/production-group";

import { ProductionGroupsConfigurationModal } from "../production-groups-configuration-modal";

interface ProductionGroupEditButtonProps {
	readonly productionGroup: ProductionGroup;
}

export const ProductionGroupEditButton: React.FC<ProductionGroupEditButtonProps> = ({ productionGroup }) => {
	const [showEdit, setShowEdit] = React.useState(false);

	return (
		<>
			<ProductionGroupsConfigurationModal
				open={showEdit}
				productionGroup={productionGroup}
				onClose={() => setShowEdit(false)}
			/>
			<IconButton
				onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
					// Blur the button to prevent Enter key from re-triggering the click
					e.currentTarget.blur();
					setShowEdit(true);
				}}
				data-testid="production-group-edit-button__button__open-modal"
				data-cy="edit-button"
				data-pendoid="production-groups__button__edit"
			>
				<EditOutlined sx={{ fontSize: 24, color: "text.primary" }} />
			</IconButton>
		</>
	);
};
